import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const QrCodeStartPageWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .logo {
    margin-top: 5rem;
  }
`;

export const ReCaptchaWrapper = styled.div`
  margin-top: 2rem;
`;

export const QrCodeStartTitle = styled.div`
  margin-top: 2rem;
  text-align: center;
  font-size: 25px;
  color: #3b3d3d;
`;

export const QrCodeStartDesc = styled.div`
  margin-top: 2rem;
  text-align: center;
  font-size: 20px;
  color: #3b3d3d;
`;

export const QrCodeStartButton = styled.button`
  border: none;
  padding: 20px 59px;
  border-radius: 15px;
  display: block;
  margin: 22px 60px;
  position: relative;
  font-size: 20px;
  font-weight: normal;
  background-color: ${COLORS.popular};
  color:${COLORS.white};

  &:hover {
    background-color: ${COLORS.available};
    color: ${COLORS.stone};
  }

  &:disabled {
    background-color: ${COLORS.secondary};
    cursor: not-allowed;
    border: none;
    &:hover {
      color: #555;
    }
  }
`;

export const QrCodeStopButton = styled.button`
  border: none;
  padding: 19px 63px;
  border-radius: 15px;
  display: block;
  margin: 0px 60px;
  position: relative;
  font-size: 20px;
  font-weight: normal;
  background-color: ${COLORS.carBrandUsage};
  color:${COLORS.white};

  &:hover {
    background-color: ${COLORS.red};
    color: ${COLORS.stone};
  }

  &:disabled {
    background-color: ${COLORS.secondary};
    cursor: not-allowed;
    border: none;
    &:hover {
      color: #555;
    }
  }
`;
